import { render } from "./ChevronLeft.vue?vue&type=template&id=1c046116"
import script from "./ChevronLeft.vue?vue&type=script&lang=js"
export * from "./ChevronLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ChevronLeft.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c046116"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c046116', __exports__)) {
    api.reload('1c046116', __exports__)
  }
  
  module.hot.accept("./ChevronLeft.vue?vue&type=template&id=1c046116", () => {
    api.rerender('1c046116', render)
  })

}


export default __exports__